
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5862',
  depVersions: {
  "data-privacy-request-ui": "static-1.5862",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.9993",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8373",
  "hub-http-shared-msw-handlers": "static-1.10682",
  "hubspot-dlb": "static-2.1905",
  "HubStyleTokens": "static-2.11832",
  "I18n": "static-7.1679",
  "jasmine-runner": "static-1.6790",
  "quartz": "static-1.7507",
  "react-dlb": "static-1.89",
  "rpc-client-utils": "static-1.5006",
  "ui-components-test-utils": "static-1.5969",
  "UIComponents": "static-3.8778",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.94",
  "foundations-assets": "static-1.5227",
  "foundations-components": "static-1.8550",
  "foundations-components-test-utils": "static-1.6033",
  "foundations-theming": "static-1.4816",
  "hub-http": "static-1.6552",
  "quartz-config": "static-1.1285",
  "quartz-core": "static-1.6726",
  "quartz-routing": "static-1.937",
  "quick-fetch": "static-1.4153",
  "raven": "static-3.5925",
  "react": "static-7.196",
  "react-rhumb": "static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11486",
  "usage-tracker": "static-1.7653",
  "usage-tracker-anonymous": "static-1.6070",
  "usage-tracker-core": "static-1.7503",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4366",
  "immutable": "static-2.87",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3784",
  "quartz-webpack": "static-1.3731",
  "bend-plugin-quartz-routing": "static-1.585",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.89",
  "HeadJS": "static-2.803",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3484",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "ts-schema": "static-1.4319",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "react-utils": "static-2.5581",
  "StyleGuideUI": "static-3.507",
  "jasmine": "static-4.4652",
  "bend-plugin-chirp-manifest": "static-1.416",
  "chirp-fetch": "static-1.2236",
  "HubStyle": "static-2.12139",
  "ui-addon-draggable": "static-3.5097",
  "cssUtils": "static-1.962",
  "hs-story-utils": "static-1.9765",
  "icons": "static-2.693",
  "react-create-root-preference": "static-1.78",
  "react-select-plus": "static-1.113",
  "react-virtualized": "static-2.107",
  "ui-images": "static-2.1262",
  "bend-plugin-foundations-components": "static-1.4819",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2532",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2736",
  "ui-fonts": "static-1.1094",
  "foundations-components-legacy": "static-1.1575",
  "bend-plugin-foundations-theming": "static-1.3299",
  "foundations-theming-base": "static-1.3801",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.320",
  "opentelemetry-fe-types": "static-1.116",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.887",
  "hubspotter-http": "static-1.4889",
  "mobile-manifest-mixins": "static-1.583",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.491",
  "quartz-auth": "static-1.1182",
  "quartz-head": "static-1.1172",
  "quartz-i18n": "static-1.1182",
  "quartz-test": "static-1.1182",
  "quartz-tracking": "static-1.886",
  "trellis-components": "static-1.2755",
  "usage-tracker-container": "static-1.7643",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3452",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.78",
  "sassPrefix": "static-1.229",
  "stylex-utils": "static-1.147",
  "trellis-theming": "static-1.1313",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.44",
  "hubspotter-http-shared-msw-handlers": "static-1.10680",
  "usage-tracker-session-replay": "static-1.5339",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5862",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.9993",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8373",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10682",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyleTokens": "/HubStyleTokens/static-2.11832",
  "I18n": "/I18n/static-7.1679",
  "jasmine-runner": "/jasmine-runner/static-1.6790",
  "quartz": "/quartz/static-1.7507",
  "react-dlb": "/react-dlb/static-1.89",
  "rpc-client-utils": "/rpc-client-utils/static-1.5006",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5969",
  "UIComponents": "/UIComponents/static-3.8778",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "foundations-assets": "/foundations-assets/static-1.5227",
  "foundations-components": "/foundations-components/static-1.8550",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6033",
  "foundations-theming": "/foundations-theming/static-1.4816",
  "hub-http": "/hub-http/static-1.6552",
  "quartz-config": "/quartz-config/static-1.1285",
  "quartz-core": "/quartz-core/static-1.6726",
  "quartz-routing": "/quartz-routing/static-1.937",
  "quick-fetch": "/quick-fetch/static-1.4153",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.196",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11486",
  "usage-tracker": "/usage-tracker/static-1.7653",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6070",
  "usage-tracker-core": "/usage-tracker-core/static-1.7503",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "immutable": "/immutable/static-2.87",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3784",
  "quartz-webpack": "/quartz-webpack/static-1.3731",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.585",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.89",
  "HeadJS": "/HeadJS/static-2.803",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3484",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "ts-schema": "/ts-schema/static-1.4319",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "react-utils": "/react-utils/static-2.5581",
  "StyleGuideUI": "/StyleGuideUI/static-3.507",
  "jasmine": "/jasmine/static-4.4652",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.416",
  "chirp-fetch": "/chirp-fetch/static-1.2236",
  "HubStyle": "/HubStyle/static-2.12139",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5097",
  "cssUtils": "/cssUtils/static-1.962",
  "hs-story-utils": "/hs-story-utils/static-1.9765",
  "icons": "/icons/static-2.693",
  "react-create-root-preference": "/react-create-root-preference/static-1.78",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-virtualized": "/react-virtualized/static-2.107",
  "ui-images": "/ui-images/static-2.1262",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4819",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2532",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2736",
  "ui-fonts": "/ui-fonts/static-1.1094",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1575",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3299",
  "foundations-theming-base": "/foundations-theming-base/static-1.3801",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.320",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.116",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.887",
  "hubspotter-http": "/hubspotter-http/static-1.4889",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.491",
  "quartz-auth": "/quartz-auth/static-1.1182",
  "quartz-head": "/quartz-head/static-1.1172",
  "quartz-i18n": "/quartz-i18n/static-1.1182",
  "quartz-test": "/quartz-test/static-1.1182",
  "quartz-tracking": "/quartz-tracking/static-1.886",
  "trellis-components": "/trellis-components/static-1.2755",
  "usage-tracker-container": "/usage-tracker-container/static-1.7643",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.78",
  "sassPrefix": "/sassPrefix/static-1.229",
  "stylex-utils": "/stylex-utils/static-1.147",
  "trellis-theming": "/trellis-theming/static-1.1313",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.44",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10680",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5339",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
